import { useState } from 'react';
import { CloseIcon } from '../../icons';
import './toast.css';

function Toast(props) {
  const { text } = props;

  const [visible, setVisible] = useState(false);

  const handleChange = () => {
    setVisible(true);
  };

  return (
    <section>
      <div>
        {!visible ? (
          <div className="notificationToast">
            <h6> {text || ''} </h6>
            <button type="button" onClick={handleChange}>
              <CloseIcon />
            </button>
          </div>
        ) : (
          ''
        )}
      </div>
    </section>
  );
}

export default Toast;
